import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/webp/common/bottom_bg.webp'


const _hoisted_1 = { class: "contents" }
const _hoisted_2 = { class: "inner" }

import { ref } from 'vue'
import { RouterView, useRouter } from 'vue-router'
import SiteFooter from '@/components/common/SiteFooter.vue'
import SiteHeader from '@/components/common/SiteHeader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()

const main = ref<HTMLElement | null>(null)
router.afterEach(() => {
  if (main.value) {
    main.value.classList.remove('is-loaded')
    void main.value.offsetWidth

    setTimeout(() => {
      if (main.value) {
        main.value.classList.add('is-loaded')
      }
    }, 100)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SiteHeader),
    _createElementVNode("main", {
      class: "main",
      ref_key: "main",
      ref: main
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(RouterView))
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bottom-bg" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          width: "828",
          height: "837",
          type: "image/webp"
        })
      ], -1))
    ], 512),
    _createVNode(SiteFooter)
  ]))
}
}

})